export default {
  presenter: 'vondra',
  title:
    'Výkon webových aplikací prakticky - změřte a spočítejte si, jak velký server potřebuje vaše aplikace',
  subtitle: 'pokročilí/zkušení administrátoři/programátoři',
  text: `
Na minulé konferenci LinuxDays jsem měl přednášku s podobným názvem. Bohužel jsem se nedostal
k praktické části. Tak tohle bude ona. Stáhneme si „neznámou“ aplikaci, nahodíme ji na Cloud,
uděláme benchmark a pomocí simulačních nástrojů si spočítáme, kolik uživatelů na dané velikosti
utáhne. Na konci budete moct každému vysvětlit, proč ne vždycky pomáhá hodit na problém víc procesorů.
Možná se dostaneme i k autoškálování.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/vondra-vykon.js